import React from "react";

const CheckboxFilter = ({
  addedFilters,
  handleInputChange,
  title,
  field,
  options,
}) => (
  <div className="mt-1 bg-white">
    {options?.map((option, index) => {
      const value =
        typeof option === "object" ? option?.value : option;
      const label =
        typeof option === "object" ? option?.label ?? value : option;
      const count = typeof option === "object" ? option?.count : undefined;

      return (
      <label
        key={index}
        className="flex cursor-pointer items-center space-x-2 rounded-md px-1 py-1 text-xs text-[#303026] hover:bg-[#FFF4EE]"
      >
        <input
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-[#E95420] focus:ring-[#E95420]"
          checked={addedFilters[field]?.includes(value)}
          onChange={() => handleInputChange(field, value, true)}
        />
        <span className="min-w-0 flex-1 truncate">{label}</span>
        {count !== undefined && (
          <span className="text-xs text-gray-500">{count}</span>
        )}
      </label>
      );
    })}
  </div>
);

const RadioFilter = ({
  addedFilters,
  handleInputChange,
  title,
  field,
  options,
  showOptions,
}) => (
  <div className="mt-1 bg-white">
    {options.map((value, index) => (
      <label
        key={index}
        className="flex cursor-pointer items-center space-x-2 rounded-md px-1 py-1 text-xs text-[#303026] hover:bg-[#FFF4EE]"
      >
        <input
          type="radio"
          name={title + "radios"}
          checked={addedFilters[field] == value}
          onChange={() => handleInputChange(field, value, false)}
          className="h-4 w-4 border-gray-300 text-[#E95420] focus:ring-[#E95420]"
        />
        <span>{value}</span>
      </label>
    ))}
  </div>
);

const SearchCheckboxFilter = ({
  addedFilters,
  handleInputChange,
  title,
  type,
  options,
}) => (
  <div className="mt-1 bg-white">
    <input
      type="email"
      id="helper-text"
      aria-describedby="helper-text-explanation"
      className="bg-gray-50 border cursor-pointer border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      placeholder="search here"
    />
  </div>
);

const RangeFilter = ({
  addedFilters,
  handleInputChange,
  title,
  type,
  options,
}) => (
  <div className="mt-1 bg-white">
    <input
      type="range"
      // min={options[0]}
      // max={options[options.length - 1]}
      // step="any"
      // value={value}
      // onChange={handleChange}
      // className="slider-thumb"
    />
    <div className="flex justify-between mt-2">
      {options.map((option, index) => (
        <span key={index}>{option}</span>
      ))}
    </div>
  </div>
);

const TagsFilter = ({}) => {
  return (
    <>
      <input
        type="email"
        id="helper-text"
        aria-describedby="helper-text-explanation"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="search here"
      />
    </>
  );
};

export {
  CheckboxFilter,
  RadioFilter,
  SearchCheckboxFilter,
  RangeFilter,
  TagsFilter,
};
